"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleTemplate = void 0;
/* eslint-disable require-jsdoc */
const firestore_1 = require("firebase/firestore");
const types_1 = require("../main/types");
const lodash_1 = __importDefault(require("lodash"));
class ModuleTemplate extends types_1.ModuleTemplateType {
    constructor() {
        super(...arguments);
        this.lastUpdateDate = firestore_1.Timestamp.now();
    }
    isEqual(other) {
        return this.id === other.id &&
            this.title === other.title &&
            this.description === other.description &&
            lodash_1.default.isEqualWith(this.subjects, other.subjects, types_1.isSubjectInfoArrayEqual) &&
            lodash_1.default.isEqual(this.parentLevelIds, other.parentLevelIds) &&
            this.imageString === other.imageString &&
            this.appAvailability.isEqual(other.appAvailability) &&
            this.lastUpdateDate.isEqual(other.lastUpdateDate) &&
            this.representationColor === other.representationColor &&
            this.cardCount === other.cardCount &&
            this.conceptCount === other.conceptCount &&
            this.studyCount === other.studyCount &&
            this.authorId === other.authorId;
    }
}
exports.ModuleTemplate = ModuleTemplate;
ModuleTemplate.converter = {
    toFirestore(data) {
        return {
            title: data.title,
            description: data.description,
            subjects: data.subjects,
            parentLevelIds: data.parentLevelIds,
            imageString: data.imageString,
            lastUpdateDate: data.lastUpdateDate,
            appAvailability: types_1.AppAvailability.converter.toObject(data.appAvailability),
            representationColor: data.representationColor,
            cardCount: data.cardCount,
            conceptCount: data.conceptCount,
            studyCount: data.studyCount,
            authorId: data.authorId
        };
    },
    fromFirestore(snapshot) {
        var _a, _b, _c;
        const documentData = snapshot.data();
        const id = snapshot.id;
        const title = documentData.title;
        const description = documentData.description;
        const appAvailability = types_1.AppAvailability.converter.fromObject(documentData.appAvailability);
        const data = new ModuleTemplate(id, title, description, appAvailability);
        data.subjects = documentData.subjects;
        data.parentLevelIds = documentData.parentLevelIds;
        data.imageString = documentData.imageString;
        data.lastUpdateDate = documentData.lastUpdateDate;
        data.representationColor = documentData.representationColor;
        data.cardCount = (_a = documentData.cardCount) !== null && _a !== void 0 ? _a : 0;
        data.conceptCount = (_b = documentData.conceptCount) !== null && _b !== void 0 ? _b : 0;
        data.studyCount = (_c = documentData.studyCount) !== null && _c !== void 0 ? _c : 0;
        data.authorId = documentData.authorId;
        return data;
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ModuleTemplate.convertFromJSON = (jsonBlob, docId) => {
    const validatedResult = ModuleTemplate.jsonSchema.safeParse(jsonBlob);
    if (!validatedResult.success) {
        // eslint-disable-next-line max-len
        throw new Error(`json blob doesn't match Module Template type: ${JSON.stringify(validatedResult.error.flatten())}`);
    }
    const data = validatedResult.data;
    const appAvailability = new types_1.AppAvailability();
    appAvailability.BIOLOGY_PROD_IOS = data.appAvailability.BIOLOGY_PROD_IOS;
    appAvailability.CHEMISTRY_PROD_IOS = data.appAvailability.CHEMISTRY_PROD_IOS;
    appAvailability.FRENCH_PROD_IOS = data.appAvailability.FRENCH_PROD_IOS;
    appAvailability.LT_DEV_IOS = data.appAvailability.LT_DEV_IOS;
    appAvailability.LT_DEV_WEB = data.appAvailability.LT_DEV_WEB;
    appAvailability.LT_PROD_IOS = data.appAvailability.LT_PROD_IOS;
    appAvailability.LT_PROD_WEB = data.appAvailability.LT_PROD_WEB;
    appAvailability.QUIZ_PROD_WEB = data.appAvailability.QUIZ_PROD_WEB;
    const moduleTemplate = new ModuleTemplate(docId, data.title, data.description, appAvailability);
    moduleTemplate.lastUpdateDate = new firestore_1.Timestamp(data.lastUpdateDate._seconds, data.lastUpdateDate._nanoseconds);
    moduleTemplate.subjects = data.subjects;
    moduleTemplate.parentLevelIds = data.parentLevelIds;
    moduleTemplate.imageString = data.imageString;
    moduleTemplate.representationColor = data.representationColor;
    moduleTemplate.cardCount = data.cardCount;
    moduleTemplate.conceptCount = data.conceptCount;
    moduleTemplate.authorId = data.authorId;
    return moduleTemplate;
};
